import { FormGroup, Validators } from '@angular/forms';
import {
  clearTextColor,
  clearValidatorsAndEnableAttribute,
  setAsRequiredAndEnable
} from './leg.utilities';
import { Leg } from '@approot/models';
import { Utilities } from '@approot/utilities';
import {
  accumulatorBarrierObsType,
  accumulatorMultiPeriodBarrierTypeChange,
  accumulatorSpotSettledUpperBarrierTypeChange,
  accumulatorSpotSettledlowerBarrierTypeChange
} from './accumulator-utilities';

export function lowerBarrierTypeChanges(
  val: string,
  form: FormGroup,
  leg: Leg
) {
  if (val === 'None' && form.get('lowerBarrierObservationType')?.enabled) {
    form.get('lowerBarrierObservationType').disable();
  } else if (form.get('lowerBarrierObservationType')?.disabled) {
    form.get('lowerBarrierObservationType').enable();
  }

  if (leg.productType === 'rainbowpivottarf') {
    if (val === 'EKI') {
      setAsRequiredAndEnable('strikeBelowLowerBarrier', form);
      setAsRequiredAndEnable('countLowerEkiZone', form);
      setAsRequiredAndEnable('fixedAmountLowerEkiZone', form);
      setAsRequiredAndEnable('lowerBarrier', form);
    } else if (val === 'None') {
      form.get('strikeBelowLowerBarrier')?.disable();
      form.get('countLowerEkiZone')?.disable();
      form.get('fixedAmountLowerEkiZone')?.disable();
      form.get('lowerBarrier')?.disable();
    } else {
      clearValidatorsAndEnableAttribute('strikeBelowLowerBarrier', form);
      clearValidatorsAndEnableAttribute('countLowerEkiZone', form);
      clearValidatorsAndEnableAttribute('fixedAmountLowerEkiZone', form);
      clearValidatorsAndEnableAttribute('lowerBarrier', form);
    }
  }

  pivotLowerBarrierTypeChange(val, form);
  accumulatorSpotSettledlowerBarrierTypeChange(val, form, leg);
  accumulatorBarrierObsType(
    val,
    'lowerBarrierObservationType',
    'lowerBarrier',
    form,
    leg
  );
  accumulatorMultiPeriodBarrierTypeChange(
    val,
    'lowerBarrierObservationType',
    form,
    leg
  );

  if (form.get('schedule') && form.get('schedule').value) {
    // Only clear if a schedule has been set
    clearTextColor(leg, 'lowerBarrierType');
  }
}

export function upperBarrierTypeChange(val: string, form: FormGroup, leg: Leg) {
  if (val === 'None' && form.get('upperBarrierObservationType')?.enabled) {
    form.get('upperBarrierObservationType').disable();
  } else if (form.get('upperBarrierObservationType')?.disabled) {
    form.get('upperBarrierObservationType').enable();
  }

  if (leg.productType === 'rainbowpivottarf') {
    if (val === 'EKI') {
      setAsRequiredAndEnable('strikeAboveUpperBarrier', form);
      setAsRequiredAndEnable('countUpperEkiZone', form);
      setAsRequiredAndEnable('fixedAmountUpperEkiZone', form);
      setAsRequiredAndEnable('upperBarrier', form);
    } else if (val === 'None') {
      form.get('strikeAboveUpperBarrier')?.disable();
      form.get('countUpperEkiZone')?.disable();
      form.get('fixedAmountUpperEkiZone')?.disable();
      form.get('upperBarrier')?.disable();
    } else {
      clearValidatorsAndEnableAttribute('strikeAboveUpperBarrier', form);
      clearValidatorsAndEnableAttribute('countUpperEkiZone', form);
      clearValidatorsAndEnableAttribute('fixedAmountUpperEkiZone', form);
      clearValidatorsAndEnableAttribute('upperBarrier', form);
    }
  }

  pivotUpperBarrierTypeChange(val, form);
  accumulatorSpotSettledUpperBarrierTypeChange(val, form, leg);
  accumulatorBarrierObsType(
    val,
    'upperBarrierObservationType',
    'upperBarrier',
    form,
    leg
  );
  accumulatorMultiPeriodBarrierTypeChange(
    val,
    'upperBarrierObservationType',
    form,
    leg
  );
  if (form.get('schedule') && form.get('schedule').value) {
    clearTextColor(leg, 'upperBarrierType');
  }
}

export function clearBarrierCustomOnTypeChange(
  key: string,
  form: FormGroup
): void {
  // takes barrier Type
  const barrier = key.substring(0, key.length - 4);
  if (form.get(barrier) && form.get(barrier).value === Utilities.customText) {
    // if the barrier is has the string custom remove it
    form.get(barrier).setValue('');
  }
}

export function barrierTypeValDisablerEnabler(
  barrierType: string,
  barrier: string,
  val: string,
  form: FormGroup,
  leg: Leg
) {
  // this function if the drop down is none
  // proceeds to set the barrier to empty string disables it, and says that it is valid

  if (form.get(barrier)) {
    if (val === 'None') {
      form.get(barrier).setValue('');
      form.get(barrier).disable();
      form.get(barrier).setErrors(null);
    } else {
      if (form.get(barrier).value === Utilities.customText) {
        form.get(barrier).setValue(''); // if the val is custom just wipe the barrier
      }
      form.get(barrier).enable();
    }
  }

  if (form.get('schedule')) {
    clearTextColor(leg, barrierType);
  }
}

function pivotLowerBarrierTypeChange(val: string, form: FormGroup): void {
  if (
    form.get('lowerBarrierType') &&
    form.get('upperBarrierType') &&
    form.get('pivot')
  ) {
    if (val === 'None') {
      // RULE: if set to none, there is no need to validate the barrier field.
      form.get('lowerBarrier').setValue('');
      form.get('lowerBarrier').clearValidators();
      form.get('lowerBarrier').updateValueAndValidity();
    } else {
      form.get('lowerBarrier').setValidators([Validators.required]);
      form.get('lowerBarrier').updateValueAndValidity({ emitEvent: false });
    }
  }
}

function pivotUpperBarrierTypeChange(val: string, form: FormGroup): void {
  if (
    form.get('lowerBarrierType') &&
    form.get('upperBarrierType') &&
    form.get('pivot')
  ) {
    if (val === 'None') {
      form.get('upperBarrier').setValue('');
      form.get('upperBarrier').clearValidators();
      form.get('upperBarrier').updateValueAndValidity();
    } else {
      form.get('upperBarrier').setValidators([Validators.required]);
      form.get('upperBarrier').updateValueAndValidity({ emitEvent: false });
    }
  }
}
